import React from 'react';
import './Welcome.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Welcome = () => {
  return (
    <div className="welcome">
      <div className="welcomeTop">

      </div>
      <div className="welcomeMiddle">
        <h1>Welcome to my page! I am a Full-Stack Developer.</h1>
        <p>My name is Anna Kucherenko. I am an Ukrainian based in Europe with a passion for web development. </p>
      </div>
      <div className="welcomeBottom">
        <div className='links'>
        <p>You can reach me on LinkedIn if you want to collaborate.</p>
        <a href="https://www.linkedin.com/in/anna-kucherenko1/">
          <FontAwesomeIcon className='icon' icon={faLinkedin} />
        </a>
        <a href="https://github.com/AnnaKucherenko1">
          <FontAwesomeIcon className='icon' icon={faGithub} />
        </a>
        </div>
      </div>
    
    </div>
  );
}

export default Welcome;
